import { render, staticRenderFns } from "./invite_friends.vue?vue&type=template&id=34506afd&scoped=true"
import script from "./invite_friends.vue?vue&type=script&lang=js"
export * from "./invite_friends.vue?vue&type=script&lang=js"
import style0 from "./invite_friends.vue?vue&type=style&index=0&id=34506afd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34506afd",
  null
  
)

export default component.exports